enum SignatureDialogFields {
	FIELD = "field",
	FIELD_NAME = "field_name",
	CERTIFICATE = "certificate",
	CERTIFICATE_PASSWORD = "certificate_password",
	CERTIFICATE_MANUAL = "certificate_manual",
	PRIVATE_KEY = "private_key",
	PRIVATE_KEY_PASSWORD = "private_key_password",
	FILE = "file",
	OPACITY = "opacity",
	POSITION = "position",
	REASON = "reason",
	LOCATION = "location",
	CONTACT = "contact",
	LEVEL = "level",
	PERSONAL_SIGNED_BY = "personal_signed_by",
	PERSONAL_NAME = "personal_name",
	PERSONAL_EMAIL = "personal_email",
	ORGANISATION_COMMON_NAME = "organisation_common_name",
	ORGANISATION_UNIT = "organisation_unit",
	ORGANISATION_NAME = "organisation_name",
	ENVIRONMENT_LOCALE = "environment_locale",
	ENVIRONMENT_STATE = "environment_state",
	ENVIRONMENT_COUNTRY = "environment_country",
	ENVIRONMENT_DATE = "environment_date",
	MODIFICATION_NAME = "modification_name",
	MODIFICATION_IDENTIFIER = "modification_identifier",
	APPEARANCE = "appearance",
	COMMON_NAME = "common_name",
	IDENTIFIER_PREFIX = "identifier_prefix"
}

export default SignatureDialogFields;